import createEnum from 'scripts/lib/create_enum';

var UserCredentialType = createEnum('ACTIVATION_TOKEN', 'PASSWORD', 'RESET_PASSWORD_TOKEN');

export default UserCredentialType;
